var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTwoArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5234 7.27857L8.13531 0.186035L6.75024 1.62881L13.3869 7.99995L6.75024 14.3711L8.13531 15.8139L15.5234 8.72134C15.7198 8.53277 15.8308 8.27225 15.8308 7.99995C15.8308 7.72766 15.7198 7.46714 15.5234 7.27857Z",
    fill: "#8F96A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85661 7.27857L1.46856 0.186035L0.0834961 1.62881L6.7201 7.99995L0.0834961 14.3711L1.46856 15.8139L8.85661 8.72134C9.05304 8.53277 9.16408 8.27225 9.16408 7.99995C9.16408 7.72766 9.05304 7.46714 8.85661 7.27857Z",
    fill: "#8F96A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwoArrowRight);
export default __webpack_public_path__ + "static/media/ic_two_arrow_right.6d8b1c73abbc11e70d10d5e40faf0620.svg";
export { ForwardRef as ReactComponent };